import { api } from "app/data/api";

export const getUserResearchProject = async (userId?: number ) => {
    return await api.get('user/getUserReseachProject', {
        params: {
            userId
        }
    })
}

export const updateReseachProject = async (researchProject: ResearchProject) => {
    return await api.post('user/updateUserResearchProject', {
        ...researchProject
    })
}

export const deleteResearchProject = async (id: number) => {
    return await api.delete('user/deleteUserResearchProject', {
        params: {
            id
        }
    })
}

export type UserReseachProjects = UserReseachProject[]

export interface UserReseachProject {
  id: number
  user_id: number
  research_project_id: number
  active: number
  created_at: string
  updated_at: string
  research_project: ResearchProject
}

export interface ResearchProject {
  id: number
  title: string
  author: string
  proccess: string
  financier: string
  type: string
  division_id: number
  status: string
  initial_date: string
  end_date: string
  summary: string
  created_by: number
  created_at: string
  updated_at: string
  division: Division
  user: User
}

export interface Division {
  id: number
  name: string
  institution_id: number
  created_by: any
  active: number
  approved_by: any
  created_at: string
  updated_at: any
}

export interface User {
  id: number
  name: string
  email: string
  cpf: string
  created_at: string
  updated_at: string
  active: number
}